import { Dialog, DialogContent } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { DialogTitleClosable } from "../../components/DialogTitleClosable";
import { iotGatewayEvents } from "../../data/iotGatewayEvents.data";
import { formatDateTime } from "../../utils";
import { IotGatewayEventDto } from "./dtos/IotGatewayEventDto";


const columnDefinitions: GridColDef[ ] = [

    {
        field: 'approved',
        headerName: 'Approved',
        width: 100,
        editable: true,
        headerAlign: 'center',
        align: 'center',
        type: 'boolean'
    },

    {
        field: 'apUpTime',
        headerName: 'Ap Up Time',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: 'connected',
        headerName: 'Connected',
        width: 100,
        editable: true,
        headerAlign: 'center',
        align: 'center',
        type: 'boolean'
    },

    {
        field: 'createdOn',
        headerName: 'createdOn',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
        renderCell: ( params => formatDateTime( params.row.createdOn ))
    },

    {
        field: 'gatewayEuid',
        headerName: 'Gateway Euid',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: 'gatewayName',
        headerName: 'Gateway Name',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: 'getNetworkId',
        headerName: 'Get Network Id',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: 'getNetworkType',
        headerName: 'Get Network Type',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: 'getRadioChannel',
        headerName: 'Get Radio Channel',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: 'getRadioTxPower',
        headerName: 'Get Radio Tx Power',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    // {
    //     field: 'getVlanEnable',
    //     headerName: 'Get Vlan Enable',
    //     width: 200,
    //     editable: true,
    //     headerAlign: 'center',
    //     align: 'center',
    //     type: 'boolean'
    // },

    // {
    //     field: 'getVlanMode',
    //     headerName: 'Get Vlan Mode',
    //     width: 200,
    //     editable: true,
    //     headerAlign: 'center',
    //     align: 'center',
    // },

    {
        field: 'iotFirmware',
        headerName: 'IoT Firmware',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: 'ip',
        headerName: 'IP',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: 'networkExtId',
        headerName: 'Network Ext Id',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: 'networkMac',
        headerName: 'Network Mac',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    // {
    //     field: 'networkStatus',
    //     headerName: 'Network Status',
    //     width: 200,
    //     editable: true,
    //     headerAlign: 'center',
    //     align: 'center',
    // },

    // {
    //     field: 'setVlanMode',
    //     headerName: 'Set Vlan Mode',
    //     width: 200,
    //     editable: true,
    //     headerAlign: 'center',
    //     align: 'center',
    // },

    {
        field: 'status',
        headerName: 'Status',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: 'updatedOn',
        headerName: 'Updated On',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
        renderCell: ( params => formatDateTime( params.row.updatedOn ))
    },

    // {
    //     field: 'usbPower',
    //     headerName: 'USB Power',
    //     width: 200,
    //     editable: true,
    //     headerAlign: 'center',
    //     align: 'center',
    //     type: 'boolean'
    // },

];


type DataRow = {

    id: string;
    approved : boolean;
    apUpTime : string;
    connected : boolean;
    createdOn : Date;
    gatewayEuid : string;
    gatewayName : string;
    getNetworkId : string;
    getNetworkType : string;
    getRadioChannel : number;
    getRadioTxPower : number;
    // getVlanEnable : boolean;
    // getVlanMode : string;
    iotFirmware : string;
    ip : string;
    networkExtId : string;
    networkMac : string;
    // networkStatus : string;
    // setVlanMode : string;
    status : string;
    updatedOn : Date;
    // usbPower : boolean;

};


const dialogSx = {

    '.MuiPaper-root': { 
        maxWidth: 'fit-content',
    }

};


type IotGatewayEventsProps = {

    displayIotGatewayEvents: boolean;
    gatewayName: string;
    iotGatewayEventDtos: IotGatewayEventDto[];
    onClose(): void;

};


export const IotGatewayEvents: React.FC<IotGatewayEventsProps> = ( props: IotGatewayEventsProps ) => {

    const { displayIotGatewayEvents, gatewayName, iotGatewayEventDtos, onClose } = props; 

    const [ columns, setColumns ] = useState< GridColDef[ ] >( columnDefinitions );
    const [ open, setOpen ] = useState<boolean>( false );
    const [ pageSize, setPageSize ] = useState<number>( 10 );
    const [ rows, setRows ] = useState<DataRow[]>( [] );


    useEffect( () => {

        if( !displayIotGatewayEvents ) {

            return;

        }

        setOpen( true );

        const rows: DataRow[] = [];

        let index = 0;
        
        for( const iotGatewayEventDto of iotGatewayEventDtos ) {

            const iotGatewayStatus = iotGatewayEvents.find( be => be.event === iotGatewayEventDto.status );

            if( !iotGatewayStatus ) {
                
                throw Error( `IoT Gateway status ${iotGatewayEventDto.status} not found` );

            }
            
            rows.push({

                id : index.toString( ),
                approved : iotGatewayEventDto.approved,
                apUpTime : iotGatewayEventDto.apUpTime,
                connected : iotGatewayEventDto.connected,
                createdOn : iotGatewayEventDto.createdOn,
                gatewayEuid : iotGatewayEventDto.gatewayEuid,
                gatewayName : iotGatewayEventDto.gatewayName,
                getNetworkId : iotGatewayEventDto.getNetworkId,
                getNetworkType : iotGatewayEventDto.getNetworkType,
                getRadioChannel : iotGatewayEventDto.getRadioChannel,
                getRadioTxPower : iotGatewayEventDto.getRadioTxPower,
                // getVlanEnable : iotGatewayEventDto.getVlanEnable,
                // getVlanMode : iotGatewayEventDto.getVlanMode,
                iotFirmware : iotGatewayEventDto.iotFirmware,
                ip : iotGatewayEventDto.ip,
                networkExtId : iotGatewayEventDto.networkExtId,
                networkMac : iotGatewayEventDto.networkMac,
                // networkStatus : iotGatewayEventDto.networkStatus,
                // setVlanMode : iotGatewayEventDto.setVlanMode,
                status : iotGatewayEventDto.status,
                updatedOn : iotGatewayEventDto.updatedOn,

            });

            ++index;

        }

        setRows( rows );

    }, [displayIotGatewayEvents] );


    const handleClose = ( ) => {
        
        
        setOpen( false );
        onClose( );

    }

        
    return(

        <Dialog
            onClose={handleClose}
            open={open}
            sx={dialogSx}
        >
            <DialogTitleClosable onClose={handleClose}>
                Events for {gatewayName}
            </DialogTitleClosable>
            
            <DialogContent dividers>

                <DataGrid
                    rows={rows}
                    columns={columns}
                    disableSelectionOnClick
                    sx={{ width: 1600 }}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    autoHeight={true}
                    initialState={{
                        sorting: {
                          sortModel: [{ field: 'createdOn', sort: 'asc' }],
                        }
                    }}
                />

            </DialogContent>
        </Dialog>

    );

};